import React from 'react'
import { Box, Toolbar } from '@perk-ui/core'
import { Redirect, Route, Switch, useLocation } from 'react-router'

import PrivateRoute from '../components/PrivateRoute'
import config from '../config/app-config'
import { pathsWithoutSidebar } from '../config/constants'
import { useAuth } from '../features/auth/AuthContext'
import ForgotPassword from './Authentication/ForgotPassword/ForgotPassword'
import Login from './Authentication/Login/Login'
import PasswordReset from './Authentication/PasswordReset/PasswordReset'
import Home from './Home/Home'
import MyAccess from './MyAccess/MyAccess'
import MyStudies from './MyStudies/MyStudies'
import MyTeams from './MyTeams/MyTeams'
import QuickStats from './QuickStats/QuickStats'
import RawData from './RawData/RawData'

const Routes: React.FC = React.memo(() => {
  const { isAuthenticated } = useAuth()
  const { pathname } = useLocation()
  const isCurrentLocation = (path: string) => pathname.startsWith(path)

  let showToolbar = true
  if (pathsWithoutSidebar.some(isCurrentLocation)) showToolbar = false
  return (
    <Box
      component="main"
      sx={{ flexGrow: 1, px: 3, backgroundColor: '#FAFAFB' }}
    >
      {showToolbar && <Toolbar style={{ height: '64px' }} />}
      <Switch>
        {/**
         * Authentication
         */}
        <Route path={config.unAuthenticatedRootUrl} component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/password-reset/:token" component={PasswordReset} />

        {/**
         * Home
         */}
        <PrivateRoute path="/home" component={Home} />

        <PrivateRoute path="/my-access" component={MyAccess} />
        <PrivateRoute path="/my-teams" component={MyTeams} />
        <PrivateRoute path="/my-studies" component={MyStudies} />
        <PrivateRoute path="/raw-data" component={RawData} />

        {/* Quick Stats */}
        <PrivateRoute path="/quick-stats" component={QuickStats} />

        {/**
         * Catch-all
         */}
        <Route
          path="*"
          render={() => (
            <Redirect
              to={
                isAuthenticated
                  ? config.authenticatedRootUrl
                  : config.unAuthenticatedRootUrl
              }
            />
          )}
        />
      </Switch>
    </Box>
  )
})

export default Routes
